export default "__VITE_ASSET__DnTkF8NQ__"